import { render, staticRenderFns } from "./Asignacionesv2.vue?vue&type=template&id=62a2f6c3"
import script from "./Asignacionesv2.vue?vue&type=script&lang=js"
export * from "./Asignacionesv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports